
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminConfigPage from "./AdminConfigPage";
import { getAdminConfig, saveAdminConfig } from "./api/adminConfigApi";

const AdminCategoryConfig = () => {
    const { category } = useParams();

    // ✅ GET plantGuid from localStorage or context
    // const plantGuid = "";

    const [configItems, setConfigItems] = useState([]);
    const [initialSettings, setInitialSettings] = useState({});
    const [keyIdMap, setKeyIdMap] = useState({}); // 🔥 NEW
    const [loading, setLoading] = useState(false);

    const categoryMap = {
        "assessment-controls": "Assessment Controls",
        "ai-configuration": "AI Configuration",
        "question-management": "Question Management",
        "scheduling-rules": "Scheduling Rules",
        "report-analytics": "Report Analytics",
    };

    const fieldTypeMap = {
        "Number of Questions (Per Assessment)": "number",
        "Total Time Duration (minutes)": "number",
        "Randomization of Questions": "toggle",
        "Back Navigation Required": "toggle",
        "Back Navigation": "toggle",
        "Total no of Question limit": "number",

        "AI question generation limit": "number",
        "Supported file upload formats": "multiselect-dropdown",
        "Maximum file size (MB)": "number",

        "Fixed Q&A configuration": "toggle",
        "AI judged Q&A configuration": "toggle",
        "Question limits (Per Assessment)": "number",
        "Bulk upload": "toggle",

        "Assignment Types": "multiselect-dropdown",
        "Max Users Per Batch": "number",
        "Schedule Overlap Restriction": "toggle",
        "Buffer Time Between Assessments (minutes)": "number",

        // NEW FIELDS
        "Work Time Period From": "datetime",
        "Work Time Period To": "datetime",
        "Required End Time": "toggle",
        "Expiry Date": "number",

        "View Reports": "toggle",
        "Export Reports": "toggle",
        "Report Retention Period (Days)": "number",
    };

    const fieldOptionsMap = {
        "Supported file upload formats": ["PDF", "Png"],
        "Assignment Types": [
            "Individual Employees",
            "Department",
            "Group",
            "One Time User",
        ],
    };

const transformValue = (key, value) => {
    const type = fieldTypeMap[key];

    if (type === "number") {
        return Number(value ?? 0);
    }

    if (type === "toggle") {
        return value === true || value === "true";
    }

    if (type === "datetime") {
        return value || "";
    }

    if (type === "multiselect-dropdown") {
        if (value == null) return [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.split(",");
        return [];
    }

    return value;
};

    console.log("transformValue", transformValue)
    useEffect(() => {
        if (!category) return;

        const fetchData = async () => {
            setLoading(true);

            try {
                // const res = await getAdminConfig(plantGuid);
                const res = await getAdminConfig();

                if (res.success && res.data) {
                    const selectedCategory = categoryMap[category];
                    const configs = res.data[selectedCategory];

                    if (!configs) return;

                    const items = [];
                    const settings = {};
                    const keyMap = {};

                    // Object.entries(configs).forEach(([key, valueObj]) => {
                    //     const type = fieldTypeMap[key] || "text";

                    //     // 🔥 IMPORTANT: expect backend to send id also
                    //     // const value = valueObj?.value ?? valueObj;
                    //     const value = valueObj?.value;
                    //     const id = valueObj?.id;

                    //     items.push({
                    //         label: key,
                    //         valueKey: key,
                    //         type,
                    //         tooltip: key,
                    //         options: fieldOptionsMap[key] || [],
                    //     });

                    //     settings[key] = transformValue(key, value);
                    //     keyMap[key] = id; // 🔥 store ID
                    // });
                    Object.entries(configs).forEach(([key, valueObj]) => {
                        const type = fieldTypeMap[key] || "text";

                        const rawValue =
                            valueObj &&
                                typeof valueObj === "object" &&
                                "value" in valueObj
                                ? valueObj.value
                                : valueObj;

                        const id = valueObj?.id;

                        console.log("Processing:", {
                            key,
                            rawValue,
                            valueObj,
                        });

                        items.push({
                            label: key,
                            valueKey: key,
                            type,
                            tooltip: key,
                            options: fieldOptionsMap[key] || [],
                        });

                        settings[key] = transformValue(key, rawValue);
                        keyMap[key] = id;
                    });
                    setConfigItems(items);
                    setInitialSettings(settings);
                    setKeyIdMap(keyMap);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [category]);

    // ✅ SAVE (ONLY ONE API)
    const handleSave = async (settings) => {
        try {
            const payload = {
                // plant_guid: plantGuid,
                configs: Object.keys(settings).map((key) => {
                    let value = settings[key];

                    if (Array.isArray(value)) value = value.join(",");
                    if (typeof value === "boolean") value = value.toString();

                    return {
                        category_key_id: keyIdMap[key], // 🔥 FIXED
                        category_value: value,
                    };
                }),
            };

            console.log("Final Payload:", payload);

            await saveAdminConfig(payload); // 🔥 ONLY ONE API

            console.log("Saved Successfully");

        } catch (error) {
            console.error("Save Error:", error);
            throw error;
        }
    };

    

    if (loading) {
        return <div style={{ padding: 40 }}>Loading...</div>;
    }

    return (
        <AdminConfigPage
            title={categoryMap[category] || "Admin Config"}
            configItems={configItems}
            initialSettings={initialSettings}
            onSave={handleSave}
        />
    );
};

export default AdminCategoryConfig;
